export default "__VITE_ASSET__DpyJPuoB__"